import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { TolgeeProvider } from "@tolgee/react";
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
function Root() {
	let [ui, setUi] = useState<any>(null);


	return <TolgeeProvider
		filesUrlPrefix="/payment/i18n/"
		apiUrl={process.env.REACT_APP_TOLGEE_API_URL}
		apiKey={process.env.REACT_APP_TOLGEE_API_KEY}
		ui={ui}
		loadingFallback={<>Loading...</>} //content to show when localization data is loading
	>
		<App />
	</TolgeeProvider>
}
root.render(
	<React.StrictMode>
		<Root />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
